import React, { useEffect } from "react";
import { SFLogo } from "../animationAssets";
import { Box, Slide } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";

import useStyled from "../../hooks/useStyled";
const { styled } = useStyled();

const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  width: "100%",
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.blue200.main,
  },
}));

export const SFLoadingSpinner = ({ size, ...props }) => {
  let finalSize;
  switch (size) {
  case "small":
    finalSize = 20;
    break;
  case "medium":
    finalSize = 25;
    break;
  case "large":
  default:
    finalSize = 30;
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress size={finalSize} {...props} />
    </Box>
  );
};

export const SFLoadingBar = ({ width = "50%" }) => (
  <Box sx={{ width, margin: "0 auto" }}>
    <LinearProgressStyled />
  </Box>
);

export const SFLoadingPage = ({ width = "20%" }) => (
  <Box sx={{ width, margin: "20px auto" }}>
    <LinearProgressStyled />
  </Box>
);

export const SFLoadingScreen = ({
  showLogo = false,
  isVisible,
  onAnimationFinished = null,
}) => {
  const animation = SFLogo();
  useEffect(() => {
    if (showLogo && onAnimationFinished && isVisible) {
      const length = animation.getDuration() * 1000;
      setTimeout(() => {
        onAnimationFinished();
      }, length);
    }
  }, []);

  return (
    <Slide direction="up" in={isVisible} appear={false} timeout={1500}>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#000000",
          zIndex: 999999,
          animation: "opacity 5s ease",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "#000000",
            background:
              "linear-gradient(108.45deg, rgba(121, 116, 128, 0) 12.64%, rgba(116, 116, 128, 0.252) 30.32%, rgba(116, 116, 128, 0.145208) 48.33%, rgba(116, 116, 128, 0.252) 66.02%, rgba(116, 116, 128, 0) 83.69%)",
            backgroundSize: "200% 200%",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            pointerEvents: "none",
            animation: "gradient-animation 5s ease infinite",
          }}
        >
          {showLogo ? animation.View : <SFLoadingBar />}
        </Box>
      </Box>
    </Slide>
  );
};

export default SFLoadingScreen;
